import { faPaperclip } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, QuestInstance, Typography } from "@joonapp/web-shared"

import StatusBadge from "../../../components/badges/statusBadge/StatusBadge"
import Card from "../../../components/card/Card"
import { completeQuestStatuses, openQuestStatuses } from "../../../constants"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import {
  getDayRepetitionString,
  getDaysFromRRuleString,
} from "../../../util/util"
import { useQuestActionsModalStore } from "../../questBoard/viewQuestModal/QuestActionsModal"

const CoachRoutineQuestCard = ({
  questInstance,
}: {
  questInstance: QuestInstance
}) => {
  const { onOpen: onOpenQuestActionsModal } = useQuestActionsModalStore()

  const byday = getDaysFromRRuleString(questInstance?.series?.recurrence)
  const subtitle = (
    <div className="flex flex-row items-center gap-1">
      {getDayRepetitionString(byday, questInstance?.series?.reminder_time)}
      {questInstance?.series?.resource && (
        <FontAwesomeIcon
          icon={faPaperclip}
          fontSize={12}
          color={JoonUIColor.icon.accent}
        />
      )}
    </div>
  ) as any
  const isCompleted = completeQuestStatuses.includes(questInstance.status)

  const onClickCard = () => {
    trackAnalyticEvent(ANALYTIC_EVENTS.OPEN_QUEST_STATUS_MODAL)
    onOpenQuestActionsModal(questInstance)
  }

  return (
    <Card
      title={
        <Typography
          variant="bodySmallBold"
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textDecoration: isCompleted ? "line-through" : "none",
          }}
        >
          {questInstance?.series?.title.slice(0, 72)}
        </Typography>
      }
      subtitle={subtitle}
      userIds={[questInstance.user_id]}
      buttonComponent={
        !openQuestStatuses.includes(questInstance.status) && (
          <StatusBadge status={questInstance.status} />
        )
      }
      borderColor={JoonUIColor.border.default}
      onClick={onClickCard}
      style={{ boxShadow: "none" }}
    />
  )
}

export default CoachRoutineQuestCard
